import ApolloProvider from '_graphql';
import { Toaster } from 'react-hot-toast';

import LayoutProvider from 'layouts';
import { Tooltip } from 'react-tooltip';
import RoutesProvider from 'router';
import { MantineProvider } from '@mantine/core';
import SubdomainResolver from 'components/subdomain-resolver';
import TenantProvider from 'providers/tenant-provider';
import TenantBrandingProvider from 'providers/tenant-branding-provider';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '@store/store';

function App() {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MantineProvider>
          <ApolloProvider>
            <TenantProvider>
              <SubdomainResolver>
                <TenantBrandingProvider>
                  <RoutesProvider>
                    <LayoutProvider />
                    <Tooltip id="global-tooltip" />
                    <Toaster />
                  </RoutesProvider>
                </TenantBrandingProvider>
              </SubdomainResolver>
            </TenantProvider>
          </ApolloProvider>
        </MantineProvider>
      </PersistGate>
    </ReduxProvider>
  );
}

export default App;
